module.exports = __webpack_public_path__ + "static/media/GT4_thermal-storage.2de8dc61.jpg";